var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLelyKetosisList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250.5,
    r: 250,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 105c0-27 34-49 77-49s78 22 78 49c0 26-35 48-78 48s-77-22-77-48Zm117 0 7-33-9 4-5 21-7-15-7 3 11 23v22l10 4Zm-17 13-10-4V87l-9 4v27l19 9Zm-27-27-14-6v39l14-6v-7l-7 2v-5l7-1v-4l-7-2v-5l7 2Zm-19 27-12 4V78l-10-5v63l22-10Zm-37 209 41 45c4 6 11 9 17 9 7 0 13-3 18-9l40-45c4-3 9-4 12-1 4 2 4 7 1 10l-41 46c-8 9-19 14-30 14s-23-5-30-13l-41-46c-3-4-2-8 1-11 4-3 9-2 12 1Zm33-92c4 3 7 7 8 12l11 50 7 31 1 2 3 1 3-1v-3l7-30 6-31c1-5 4-10 8-12 4-3 8-4 13-4s9 1 13 4c4 2 7 7 8 12l4 22 3 3h39c5 0 9 4 8 8 0 4-3 8-8 8h-37c-10 0-19-7-21-16l-4-22h-1l-1-2-2-1-3 1-1 2h-1l-6 31-7 31c-1 4-4 9-8 11-3 3-8 4-12 4-5 0-10-1-13-4-4-3-7-7-8-11l-7-31-10-51h-1l-1-2-3-1-2 1-1 2h-1l-8 42c-2 8-11 15-21 15h-38c-4 0-8-3-8-7 0-5 3-8 8-8h39l3-2 9-42c1-5 4-9 8-12 3-2 8-4 12-4 5 0 9 2 13 4Zm124-32a75 75 0 0 1 19 64c0 4-4 7-8 7h-2c-4-1-7-5-6-9v-10c0-16-6-30-16-42a51 51 0 0 0-78 3l-2 1c-2 1-4 2-6 1h-3l-1-1-2-1a52 52 0 0 0-40-19c-14 0-27 6-38 16a60 60 0 0 0-16 42v10c1 4-2 8-7 9h-1c-4 0-7-3-7-6v-1l-1-12c0-19 8-38 21-52a68 68 0 0 1 95-5l1 1 2-1a69 69 0 0 1 96 5Z",
    fill: "#CF1322"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLelyKetosisList);
export default __webpack_public_path__ + "static/media/lely-ketosis-list.0321e5f6.svg";
export { ForwardRef as ReactComponent };